import { useParams } from "react-router-dom";
import useCohort from "cohorts/hooks/useCohort";
import { useFetcher } from "~/hooks/useFetcher";
import { DomainIconOptions } from "~/types/enums/domain";

export interface DomainFilterOption {
  id: string;
  name: string;
  export_filter_allowed: boolean;
  export_filter_required: boolean;
  export_filter_max_options: number | null;
}

export interface DomainDefinition {
  id: string;
  name: string;
  export: boolean;
  /** True if any columns in this domain are enabled for visualization (from cohort explorer config). */
  visual: boolean;
  filters: DomainFilterOption[];
  icon?: DomainIconOptions | null;
}

const useDomains = () => {
  const { data: cohort } = useCohort();
  const { datasetId = cohort?.dataset_id } = useParams();
  return useFetcher<DomainDefinition[]>(
    datasetId ? `/api/cohort-explorer/domains?dataset_id=${datasetId}` : null
  );
};

export default useDomains;
